<div class="container">
  <h1 class="text-center bg-warning">Allergies Report</h1>
  <div class="row">

    <mat-form-field appearance="outline" class="col-md-3">
      <mat-label>Select a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [(ngModel)]="mStartDate" placeholder="Start date">
        <input matEndDate [(ngModel)]="mEndDate" placeholder="End date">
      </mat-date-range-input>
      <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
<!--    <mat-form-field appearance="outline" class="col-md-3">-->
<!--      <mat-label>Select Centre</mat-label>-->
<!--      <mat-select #selectElement [(ngModel)]="selectedCentreCode" >-->
<!--        <mat-option *ngFor=" let c of (centres$|async) "-->
<!--                    [value]="c.centreCode">{{c.centreName}} </mat-option>-->
<!--      </mat-select>-->
<!--    </mat-form-field>-->

    <app-searchable-select class="col-md-4"
                           [(ngModel)]="selectedCentreCode"
                           [options]="centres$ | async"
                           [selectedValue]="selectedCentre"
                           [displayWithFn]="displayCentre"
                           [placeholder]="'Select Centre'"
                           [label]="'Select Centre'"
                           (selectionChange)="onCentreSelect($event)"
    ></app-searchable-select>





    <button mat-mini-fab (click)="search()"><mat-icon>search</mat-icon></button>
    <button  class="mx-2" mat-mini-fab color="accent" (click)="Clear()"><mat-icon>clear</mat-icon></button>

  </div>

  <div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown">
        <h2>Allergies Type Report</h2>
      </li>
      <li class="dropdown m-l-20">
        <label for="search-input"><i class="material-icons search-icon">search</i></label>
        <input placeholder="Search" type="text" class="browser-default search-field"
               (keyup)='applyFilter($event)' aria-label="Search box" #input>
      </li>
    </ul>
    <ul class="header-buttons mr-2">
      <!--      <li>-->
      <!--        <button   mat-mini-fab color="primary" (click)="openAddCarLog()">-->
      <!--          <mat-icon class="col-white" >add</mat-icon>-->
      <!--        </button>-->
      <!--      </li>-->
      <li>
        <div  class="export-button m-l-10" matTooltip="XLSX" (click)="exportexcel()" permission="Allergy Report" [permissionTypes]="[PermissionType.ALL, PermissionType.EXCEL]">
          <img src="assets/images/icons/xlsx.png" alt="" />
        </div>
      </li>
    </ul>
  </div>

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 table table-striped table-bordered" id="excel-table">

    <!-- Child Name Column -->
    <ng-container matColumnDef="childName">
      <th mat-header-cell *matHeaderCellDef> Child Name </th>
      <td mat-cell *matCellDef="let element"> {{element.childName}} </td>
    </ng-container>

    <!-- Allergies Column -->
    <ng-container matColumnDef="allergies">
      <th mat-header-cell *matHeaderCellDef> Allergies </th>
      <td mat-cell *matCellDef="let element"> {{element.allergies}} </td>
    </ng-container>

    <!-- Centre Name Column -->
    <ng-container matColumnDef="centreName">
      <th mat-header-cell *matHeaderCellDef> Centre Name </th>
      <td mat-cell *matCellDef="let element"> {{element.centreName}} </td>
    </ng-container>
    <!-- DoA -->
    <ng-container matColumnDef="DoA">
      <th mat-header-cell *matHeaderCellDef> DoA </th>
      <td mat-cell *matCellDef="let element">  {{element.dateOfAdmission.toDate()|date:'dd-MM-yyyy'}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>


    <!-- No Data Row -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell text-center fw-bold text-danger" [attr.colspan]="displayedColumns.length">
        No data found
      </td>
    </tr>

  </table>
  <mat-paginator [pageSizeOptions]="[25,50,100,200,250,500,1000]" showFirstLastButtons></mat-paginator>

</div>

